import { FC, useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import { Link, useSearchParams } from "react-router-dom";
import { Container, Header, List } from "semantic-ui-react";
import { NavBar } from "./NavBar";
import { API, GraphQLQuery } from "@aws-amplify/api";
import { validatePayment } from "../graphql/mutations";
import { accountId } from "../accounts";
import { GetAccountQuotaQuery, ValidatePaymentMutation } from "../API";
import { UserOrUndefined } from "../auth/auth";
import { useBehaviorSubject } from "../hooks";
import { getAccountQuota } from "../graphql/queries";

export const CheckoutResult: FC = () => {
    const { result } = useParams<{ result: string }>();
    const [searchParams, _] = useSearchParams();
    const sessionId = searchParams.get('session_id');

    const aid = useContext(accountId)

    const [paymentInfo, setPaymentInfo] = useState<{
        amountTotal: number; currenty: string; description: string; purchasedQuota: number} | undefined>(undefined);

    useEffect(() => {
        const doValidatePayment = async () => {
            const validateResult = await API.graphql<GraphQLQuery<ValidatePaymentMutation>>({
                query: validatePayment,
                variables: {
                    accountId: aid,
                    sessionId
                }
            })
            setPaymentInfo(JSON.parse(validateResult.data?.validatePayment?.body || '{}'))
        }
        if (result === 'success') {
            doValidatePayment();
        }
    }, []);

    if (result === 'failure') {
        return (
            <Container>
                <NavBar/>
                <div>Payment failed, please retry</div>
                <div><Link to="/products">Go back to Products</Link></div>
            </Container>
        )
    }

    if (paymentInfo === undefined) return (
        <Container>
            <NavBar/>
            <div>Validating payment...</div>
        </Container>
    )

    return (
        <Container>
            <NavBar/>
            <Header as={'h1'}>Checkout Result</Header>
            <Header as='h4'>Payment succeeded, thank you!</Header>
            <List>
                <List.Item>
                    <List.Header>Amount</List.Header>
                    {paymentInfo.amountTotal} {paymentInfo.currenty}
                </List.Item>
                <List.Item>
                    <List.Header>Description</List.Header>
                    {paymentInfo.description}
                </List.Item>
                <List.Item>
                    <List.Header>Purchased Quota</List.Header>
                    {paymentInfo.purchasedQuota}
                </List.Item>
            </List>
            <div><Link to="/products">Go back to Products</Link></div>
        </Container>
    )
}